import { render, staticRenderFns } from "./TieredPlans.vue?vue&type=template&id=f9058db8&scoped=true&"
import script from "./TieredPlans.vue?vue&type=script&lang=ts&"
export * from "./TieredPlans.vue?vue&type=script&lang=ts&"
import style0 from "./TieredPlans.vue?vue&type=style&index=0&id=f9058db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9058db8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f9058db8', component.options)
    } else {
      api.reload('f9058db8', component.options)
    }
    module.hot.accept("./TieredPlans.vue?vue&type=template&id=f9058db8&scoped=true&", function () {
      api.rerender('f9058db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/TieredPlans.vue"
export default component.exports